import React, { Fragment, Suspense } from "react";
import { useProductFullDetail } from "../../Pregrine/ProductFullDetail/useProductFullDetail";
import PinCodeCheck from "../../components/PinCodeCheck/PinCodeCheck";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import classes from "./productFullDetail.module.css";
import { useGetReviews } from "../../Pregrine/Review/useGetReviews";
import { useAddReview } from "../../Pregrine/Review/useAddReview";
import ProductReview from "../ProductReview/ProductReview";
import classNames from "classnames";
import Carousel from "../ProductImageCarousel";
import DetailPageDetails from "../DetailPageDetails/DetailPageDetails";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import InfluencerVideoModal from "../../components/ProductDetailsPage/InfluencerVideoModal";
const ProductSpecifications = React.lazy(() =>
  import("../ProductSpecifications/ProductSpecifications")
);
const CombinationProducts = React.lazy(() =>
  import("../combinationProducts/CombinationProducts")
);
const RelatedProducts = React.lazy(() =>
  import("../RelatedProducts/RelatedProducts")
);

const ProductFullDetail = (props) => {
  const { product, ConfigData, setProductSchemaData } = props;
  const talonProps = useProductFullDetail({ product, setProductSchemaData });
  const {
    cartActionContent,
    mediaGalleryEntries,
    productDetails,
    optionSelections,
    availableOptions,
    handleSelectionChange,
    errorMessage,
    regularPrice,
    discountPrice,
    openPinCodeModal,
    pinCodeCheckFun,
    setProductZoom,
    zoom,
    notifyMe,
    modalContent,
    handlePinCodeModal,
    setQuantity,
    quantity,
    showReviewModal,
    handleCloseReviewModal,
    handleShowReviewModal,
    showThreeDModal,
    setShowThreeDModal,
    modelData,
    modelLoading,
    buyNowActionContent,
    selectedBundle,
    setSelectedBundle,
    configProductVariantId,
    isOutOfStock,
    selectedOptionsArray,
    bundleOptionsInProduct,
    isMissingOptions,
    vritualProductData,
    pincodeDataFromModal,
    setPincodeDataFromModal,
    isScrolledDown,
    setCategoryNames,
    influencerModalData,
    setInfluencerModalData,
    selectedVariantsArray,
  } = talonProps;

  const reviewProps = useGetReviews({ product });
  const { ReviewData, reviewMetaData } = reviewProps;

  const addReviewProps = useAddReview();
  const { AddReview } = addReviewProps;
  return (
    <Fragment>
      <div className={classes.root}>
        <Breadcrumbs
          product={product.categories}
          setCategoryNames={setCategoryNames}
        />
        <section className="prodetails mt-2">
          <div className={classNames("container", classes.productContainer)}>
            <div className="row">
              <div className="col-md-5">
                <Carousel
                  zoom={zoom}
                  setProductZoom={setProductZoom}
                  images={mediaGalleryEntries}
                  showThreeDModal={showThreeDModal}
                  setShowThreeDModal={setShowThreeDModal}
                  modelData={modelData}
                  modelLoading={modelLoading}
                  product={product}
                  flagText={productDetails?.flag_text}
                />
              </div>
              <div className="col-md-7">
                <DetailPageDetails
                  ConfigData={ConfigData}
                  discountPrice={discountPrice}
                  regularPrice={regularPrice}
                  product={product}
                  cartActionContent={cartActionContent}
                  buyNowActionContent={buyNowActionContent}
                  notifyMe={notifyMe}
                  zoom={zoom}
                  errorMessage={errorMessage}
                  availableOptions={availableOptions}
                  optionSelections={optionSelections}
                  handleSelectionChange={handleSelectionChange}
                  setQuantity={setQuantity}
                  quantity={quantity}
                  reviewData={ReviewData}
                  handleShowReviewModal={handleShowReviewModal}
                  selectedBundle={selectedBundle}
                  setSelectedBundle={setSelectedBundle}
                  configProductVariantId={configProductVariantId}
                  isOutOfStock={isOutOfStock}
                  selectedOptionsArray={selectedOptionsArray}
                  productDetails={productDetails}
                  vritualProductData={vritualProductData}
                  pincodeDataFromModal={pincodeDataFromModal}
                />
              </div>
            </div>
          </div>
        </section>
        <br />
        <hr />
        <br />
        <LazyLoadComponent>
          {!isOutOfStock && (
            <Suspense fallback={null}>
              <CombinationProducts
                product={{ ...productDetails, selectedVariantsArray }}
                discountPrice={discountPrice}
                regularPrice={regularPrice}
                mediaGalleryEntries={mediaGalleryEntries}
                selectedOptionsArray={selectedOptionsArray}
                bundleOptionsInProduct={bundleOptionsInProduct}
                isMissingOptions={isMissingOptions}
              />
            </Suspense>
          )}
          {isScrolledDown ? (
            <>
              <Suspense fallback={null}>
                <ProductSpecifications
                  product={product}
                  reviewData={ReviewData}
                  productDetails={productDetails}
                  selectedBundle={selectedBundle}
                  setInfluencerModalData={setInfluencerModalData}
                />
              </Suspense>

              <Suspense fallback={null}>
                <RelatedProducts product={productDetails} />
              </Suspense>
            </>
          ) : null}
        </LazyLoadComponent>

        <PinCodeCheck
          openPinCodeModal={openPinCodeModal}
          pinCodeCheckFun={pinCodeCheckFun}
          handlePinCodeModal={handlePinCodeModal}
          product={productDetails}
          setPincodeDataFromModal={setPincodeDataFromModal}
        />
        <ProductReview
          product={product}
          showReviewModal={showReviewModal}
          handleCloseReviewModal={handleCloseReviewModal}
          reviewMetaData={reviewMetaData}
          AddReview={AddReview}
        />
        <InfluencerVideoModal
          show={influencerModalData?.show}
          modalData={influencerModalData}
          handleClose={() =>
            setInfluencerModalData({ show: false, data: null })
          }
        />
        {modalContent}
      </div>
    </Fragment>
  );
};

export default ProductFullDetail;
